import {SimpleFilterOption} from '@bmc-ux/adapt-angular';
export interface EmailModel {
  id: number;
  createdDate: string;
  lastPublishingDate: string;
  sendDate: string | null;
  smartNumber: string;
  receivers: string;
  title: string;
  type: string;
  isAddressed: EMAIL_IS_ADDRESSED.YES | EMAIL_IS_ADDRESSED.NO | null;
  daysSent: number;
}

export enum EMAIL_API_ACTIONS {
  GET_ALL_EMAILS = 'admin/email',
  PREVIEW = 'preview'
}

export enum EMAIL_TYPE {
  FEEDBACK = 'Feedback',
  QUARTERLY = 'Quarterly summary',
  NEW_WIP = 'New WIP products',
  AVAILABLE_WITH_NO_DATA = 'Available products with no data'
}

export enum EMAIL_IS_ADDRESSED {
  YES = 'YES',
  NO = 'NO',
}

export const EMAIL_COLUMN_CONFIG = {
  DATE: {
    header: 'Email date',
    field: 'createdDate',
    editable: false,
    width: '120px'
  },
  LAST_PUBLISHED_DATE: {
    header: 'Last published date',
    field: 'lastPublishingDate',
    editable: false,
    width: '175px'
  },
  ADDRESSED: {
    header: 'Addressed',
    field: 'isAddressed',
    editable: false,
    width: '120px'
  },
  TITLE: {
    header: 'Email title',
    field: 'title',
    editable: false,
  },
  SMART_NUMBER: {
    header: 'Smart number',
    field: 'smartNumber',
    editable: false,
    width: '145px'
  },
  RECEPIENT: {
    header: 'Recipient',
    field: 'receivers',
    editable: false,
    width: '120px'
  },
  TYPE: {
    header: 'Type',
    field: 'type',
    editable: false,
    width: '90px'
  },
  DAYS: {
    header: 'Days',
    field: 'daysSent',
    editable: false,
    width: '90px'
  },
  VIEW: {
    header: 'View email',
    field: '',
    editable: false,
    width: '120px'
  },
  LOG: {
    header: 'Log',
    field: '',
    editable: false,
    width: '120px'
  },
};

export enum EMAIL_SIMPLE_FILTER_KEY {
  EMAIL_TYPE = 'EMAIL_TYPE',
  EMAIL_IS_ADDRESSED = 'EMAIL_IS_ADDRESSED'
}

export const EMAIL_SIMPLE_FILTER_OPTIONS: { [key: string]: SimpleFilterOption[] } = {
  EMAIL_TYPE: [
    {label: EMAIL_TYPE.FEEDBACK, id: EMAIL_TYPE.FEEDBACK, data: {field: 'type'}},
    {label: EMAIL_TYPE.QUARTERLY, id: EMAIL_TYPE.QUARTERLY, data: {field: 'type'}},
    {label: EMAIL_TYPE.NEW_WIP, id: EMAIL_TYPE.NEW_WIP, data: {field: 'type'}},
    {label: EMAIL_TYPE.AVAILABLE_WITH_NO_DATA, id: EMAIL_TYPE.AVAILABLE_WITH_NO_DATA, data: {field: 'type'}}
  ],
  EMAIL_IS_ADDRESSED: [
    {label: 'Addressed', id: EMAIL_IS_ADDRESSED.YES, data: {field: 'isAddressed'}},
    {label: 'No changes', id: EMAIL_IS_ADDRESSED.NO, data: {field: 'isAddressed'}}
  ]
};
